// AUTO-GENERATED by scripts/generate-contracts.mjs from the .md sidecar.
// Hand edits will be overwritten on the next run. To customise this
// component's contract (add actions, structured props, custom control
// kinds, glyph pickers), remove this file's auto-generated marker and
// hand-author it — the generator skips files without the marker.

import { z } from "zod";
import { contract } from "@gradeui/contracts";

export const ResizableContract = contract({
  name: "Resizable",
  description: "A multi-pane layout where the user wants to drag the divider — Slack/Mail-style list+detail, IDE editor+terminal, side-by-side compare view. Static layouts shouldn't use this — reach for AppShell with nav=\"three-pane\" (fixed widths) or Grid (responsive ladder). Built on react-resizable-panels under the hood.",
  import: "@gradeui/ui",
  aliases: ["resizable","splitter","split pane","drag divider","adjustable panels","resizer","split view","draggable divider","split pane resizer","ns split view"],
  subcomponents: ["ResizablePanelGroup","ResizablePanel","ResizableHandle"],
  composesWith: ["AppShellMain (host the splitter inside main)","ScrollArea (each panel's content)","Card"],
  styleDefaults: {"ResizablePanelGroup":"flex h-full w-full data-[panel-group-direction=vertical]:flex-col","ResizableHandle":"relative flex w-px items-center justify-center bg-border after:absolute after:inset-y-0 after:left-1/2 after:w-1 after:-translate-x-1/2 focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1 data-[panel-group-direction=vertical]:h-px data-[panel-group-direction=vertical]:w-full data-[panel-group-direction=vertical]:after:left-0 data-[panel-group-direction=vertical]:after:h-1 data-[panel-group-direction=vertical]:after:w-full data-[panel-group-direction=vertical]:after:-translate-y-1/2 data-[panel-group-direction=vertical]:after:translate-x-0 [&[data-panel-group-direction=vertical]>div]:rotate-90"},
  props: {
  "direction": {
      schema: z.enum(["horizontal", "vertical"]).optional(),
      design: "knob",
      description: "required; sets the axis the user drags along",
  },
  "autoSaveId": {
      schema: z.string().optional(),
      design: "content",
      description: "persists user-adjusted sizes to localStorage under this id",
  },
  "onLayout": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "defaultSize": {
      schema: z.number().optional(),
      design: "knob",
      description: "percent of group (0-100); siblings should sum to ~100",
  },
  "minSize": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "maxSize": {
      schema: z.number().optional(),
      design: "knob",
      description: "percent bounds",
  },
  "collapsible": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "allow this panel to collapse to zero",
  },
  "collapsedSize": {
      schema: z.unknown().optional(),
      design: "plumbing",
  },
  "onCollapse": {
      schema: z.unknown().optional(),
      design: "event",
  },
  "onExpand": {
      schema: z.unknown().optional(),
      design: "event",
      description: "collapse behaviour controls",
  },
  "withHandle": {
      schema: z.boolean().optional(),
      design: "knob",
      description: "show a visible drag affordance (default just a hit-zone)",
  },
  },
});
